// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6Udw5","left":"styles_left__25nAW"};